import { useEffect, useState } from 'react';
import api from '../utils/api';

/**
 * Is online ordering of the team-made options switched on? (server/config/ordering.js:
 * on once SMS is configured). Until the server says yes, the team options keep routing
 * to "Book a Call", so a slow or failed request never sends anyone into a flow that
 * can't finish. One request per page load, shared by every caller.
 */
let cached = null;
let inFlight = null;

export const fetchOrdering = () => {
  if (cached) return Promise.resolve(cached);
  if (!inFlight) {
    inFlight = api.get('/config/ordering')
      .then(({ data }) => { cached = { teamOrdering: data?.teamOrdering === true }; return cached; })
      .catch(() => ({ teamOrdering: false }))
      .finally(() => { inFlight = null; });
  }
  return inFlight;
};

/** Test helper. */
export const __resetOrderingCache = () => { cached = null; inFlight = null; };

const useOrdering = () => {
  const [state, setState] = useState(cached || { teamOrdering: false });
  useEffect(() => {
    let alive = true;
    fetchOrdering().then((s) => { if (alive) setState(s); });
    return () => { alive = false; };
  }, []);
  return state;
};

export default useOrdering;
